import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { isAddedTimeSheet } from "../../../helpers";

export const useEndDateValidations = () => {
  const { t } = useTranslation();
  const isRequired = useCallback((value, row) => {
    if (isAddedTimeSheet(row) && !row.startDate) {
      return null;
    }
    if (!value) {
      return t("required-end-date");
    }
    return null;
  }, [t]);
  return useMemo(() => [isRequired], [isRequired])
}
